module.exports = __webpack_public_path__ + "static/media/599.7554(5).0f3a319f.pdf";